export const sxConfig = {
  buttonDialogBox: {
    height: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: 'rgb(22, 163, 74)',
    backgroundColor: 'rgba(187, 247, 208, 0.3)',
    border: '2px solid rgb(22, 163, 74)',
    borderRadius: '12px',
    fontSize: '2rem',
    fontWeight: 700,
    cursor: 'pointer',
    userSelect: 'none',
  },

  buttonDialogTypography1: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1,
  },

  buttonDialogTypography2: {
    fontWeight: 500,
    lineHeight: 1.2,
  },
};
